import { ReadLOARequest, SignLOARequest } from '@weave/schema-gen-ts/dist/schemas/agreements/v1/insys_agreements.pb';
import { SchemaInsysAgreementsAPI } from '@frontend/schema';

export const readLOA = async (req: ReadLOARequest) => SchemaInsysAgreementsAPI.ReadLOA(req, { skipValidation: true });

export const signLOA = async (req: SignLOARequest) => SchemaInsysAgreementsAPI.SignLOA(req, { skipValidation: true });
